var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1133.57 715.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff2400;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 438.13,
    y: 154.9,
    width: 256.89,
    height: 52.9,
    transform: "translate(385.22 747.93) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 877.12,
    y: 329.66,
    width: 460.01,
    height: 52.9,
    transform: "translate(1463.24 -751.01) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.51,109.77,63.86,179.41,26.45,142,153.57,14.88,191,52.29l-53.55,53.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.1,658.28,26.45,588.63l37.41-37.41L191,678.35l-37.4,37.41L100,662.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -63.44,
    y: 342.46,
    width: 179.78,
    height: 52.9,
    transform: "translate(-342.46 395.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.45,487.63v98.49h-52.9V406.34h52.9v75.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.69,374.15v3.77H301.58a7,7,0,0,1,.45-2.72,14.42,14.42,0,0,1,2.59-4.25,40.25,40.25,0,0,1,5.13-4.84,43.46,43.46,0,0,0,7-6.76,8.13,8.13,0,0,0,1.83-4.72,5.26,5.26,0,0,0-1.67-3.94,6,6,0,0,0-4.35-1.6,6.13,6.13,0,0,0-4.53,1.7,6.44,6.44,0,0,0-1.72,4.71l-4-.41a9.91,9.91,0,0,1,3.11-6.88,10.61,10.61,0,0,1,7.26-2.37,10.17,10.17,0,0,1,7.28,2.55,8.37,8.37,0,0,1,2.68,6.32,9.61,9.61,0,0,1-.78,3.77,14.93,14.93,0,0,1-2.61,3.91,63.41,63.41,0,0,1-6.05,5.62q-3.52,3-4.53,4a12.92,12.92,0,0,0-1.66,2.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 256.67,
    width: 206.51,
    height: 52.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 929.5,
    width: 179.78,
    height: 52.9,
    transform: "translate(2038.78 52.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 929.5,
    y: 658.75,
    width: 179.78,
    height: 52.9,
    transform: "translate(2038.78 1370.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 582.22,
    y: 658.75,
    width: 256.89,
    height: 52.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutGraphic);
export default __webpack_public_path__ + "static/media/about-graphic.0ddb4cde93c157f9fcf4ca1104fbe197.svg";
export { ForwardRef as ReactComponent };